import React from "react";

const Content = () => {

    return(
        <div className="kontaktcont">
            <h2>Kontakt:</h2>
            <p>055/423-994 Bijeljina<br />
            055/206-342 Bijeljina <br /> 065/874-695 Bijeljina <br />065/547-589 Bijeljina 
            <br /> 066/212-520 Brčko <br />062/346-406 Tuzla <br /> 065/651-412 Derventa i Banja Luka</p>
            <h2 style={{textAlign: 'center'}}>Mozete nas pronaći i na lokaciji:</h2>
        </div>
    );

}

export default Content;